import { EnumResolver } from "../../../../common/tables/etc/EnumResolver";
import { VariantTableRow } from "../../../../../../common/tables/product-listing/variants/VariantTableRow";
import { EnumMapper, ResolvedEnum } from "../../../../common/tables/etc/EnumMapper";

const emptyMapper: EnumMapper = {
    map(): ResolvedEnum {
        return {};
    }
};

export class VariantEnumMapper extends EnumResolver<VariantTableRow> {
    public resolveEnum(_columnName: keyof VariantTableRow): EnumMapper {
        return emptyMapper;
    }
}
